/** @format */

const english = {};

export default english;
